var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapsedFireflinkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7284",
    "data-name": "Group 7284",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 26.437,
    viewBox: "0 0 130 26.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M-1141.165-445.883c-.339.2-.609.339-.88.474-1.016.542-1.964,1.016-2.979,1.557a.409.409,0,0,0-.2.406v20.518c0,.271-.068.474-.338.542a3.393,3.393,0,0,1-3.115-.271,3.137,3.137,0,0,1-1.286-2.031,18.207,18.207,0,0,1-.2-3.318c-.068-5.417-.135-10.9-.135-16.32a5.186,5.186,0,0,1,.474-2.506,3.032,3.032,0,0,1,3.589-1.625,9.961,9.961,0,0,1,2.709,1.287c.745.406,1.49.813,2.167,1.219C-1141.3-446.018-1141.232-445.95-1141.165-445.883Z",
    transform: "translate(1150.319 448.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M-1136.6-422.605V-428.5a.483.483,0,0,1,.2-.406c2.3-1.287,4.6-2.573,6.839-3.86.609-.339,1.219-.677,1.9-1.083a10.95,10.95,0,0,0-1.219-.677c-1.016-.609-2.031-1.151-3.047-1.761a.3.3,0,0,0-.339,0c-1.287.813-2.505,1.557-3.792,2.37-.068,0-.068.068-.135.068v-4.334a.615.615,0,0,1,.2-.474c1.151-.813,2.3-1.557,3.386-2.37a.432.432,0,0,1,.406,0c1.557.88,3.183,1.828,4.74,2.709,1.083.609,2.167,1.219,3.318,1.828a4.806,4.806,0,0,1,1.964,1.9,2.862,2.862,0,0,1-.406,3.318,6.586,6.586,0,0,1-1.9,1.49c-1.557.88-3.047,1.828-4.6,2.709-1.964,1.151-3.86,2.235-5.823,3.386C-1135.516-423.283-1136.058-422.944-1136.6-422.605Z",
    transform: "translate(1145.89 446.152)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedFireflinkLogo);
export default __webpack_public_path__ + "static/media/collapsed_fireflink_logo.99e56a365f08af5668e7cc947aafcf41.svg";
export { ForwardRef as ReactComponent };